// apps/client/src/ui/kit/Wordmark.tsx (title screen, 2026-10-05) — the game's name as the brand wordmark (DESIGN.md "Display"): Nunito
// 900 set tight, its first i a dotless ı under a small coral house. The name is common.appName, so a renaming pass changes it here too;
// a name without an i is set plainly.
import { t } from '@whiskerton/content';

export function Wordmark(p: { as?: 'h1' | 'p'; className?: string }) {
  const name = t('common.appName'), i = name.indexOf('i'), Tag = p.as ?? 'h1';
  return (
    <Tag className={`wordmark ${p.className ?? ''}`} aria-label={name}>
      {i < 0 ? name : <>
        <span aria-hidden="true">{name.slice(0, i)}</span>
        <span className="wordmark-i" aria-hidden="true">ı<svg className="wordmark-house" viewBox="0 0 30 27" focusable="false">
          <path d="M3 13.5 15 3l12 10.5V24H3z" fill="var(--coral-500)" stroke="var(--coral-500)" strokeWidth="5" strokeLinejoin="round" />
        </svg></span>
        <span aria-hidden="true">{name.slice(i + 1)}</span>
      </>}
    </Tag>
  );
}
